import { QuestionsForManagerQueryOptions } from "@pulse/api/queryApi";
import { useCurrentSurvey } from "@pulse/hooks/surveyHooks";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import ResponseProvider from "./Responses/ResponseProvider";

export default function ResponseList() {
    const { t } = useTranslation();
    const { data: survey } = useCurrentSurvey();
    const { data: questions } = useQuery(QuestionsForManagerQueryOptions({ surveyId: survey?.id }));

    if (!survey || !questions) return null;

    const sortedQuestions = [...questions].sort((a, b) => a.questionOrder - b.questionOrder);

    return (
        <div>
            <h1 className="text-xl font-bold">{t("responseOverview.questionResults")}</h1>
            <ol className="space-y-6">
                {sortedQuestions.map((question, idx) => (
                    <li key={question.id}>
                        <ResponseProvider question={question} questionIndex={idx + 1} />
                    </li>
                ))}
            </ol>
        </div>
    );
}
